module.exports = __webpack_public_path__ + "static/logo-re-9c2022927388b66cbbce4e3f10d3f41c.svg";